import { render, staticRenderFns } from "./ReportParcel.vue?vue&type=template&id=3ed609f2&"
import script from "./ReportParcel.vue?vue&type=script&lang=js&"
export * from "./ReportParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports